<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="prestador.especialidades"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="$refs.ModalObservacao.open(item)"
                    color="info"
                    small
                    title="Observações"
                >
                    <rkm-icon icon="comment" />
                </rkm-button>

                <rkm-button
                    :color="item.ativo ? 'dark' : 'success'"
                    :title="item.ativo ? 'Desativar' : 'Ativar'"
                    @click="item.ativo = !item.ativo"
                    small
                >
                    <rkm-icon :icon="item.ativo ? 'ban' : 'check-circle'" />
                </rkm-button>

                <rkm-button
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalObservacao ref="ModalObservacao" />
    </div>
</template>

<script>
// Components.
import ModalObservacao from './components/observacao/Modal'

export default {
    components: { ModalObservacao },
    data() {

        return {
            fields: [
                { key: 'codigo', label: 'Código', sortable: true, class: 'col-min' },
                { key: 'nome', label: 'Nome', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ],
        }
    },
    methods: {
        destroy(especialidade) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir a especialidade?',
                async () => this.prestador.especialidades
                    .splice(this.prestador.especialidades.indexOf(especialidade), 1)
            )
        }
    },
    props: {
        prestador: { type: Object, required: true },
    }
}
</script>